import { EDA } from "motw_core/Dreams/EDreamAttribute";
import IDream from "motw_core/Entity/IDream";
import { dreamService } from "motw_core/Services/DreamService";
import * as React from "react";
import ReactTooltip from "react-tooltip";
import { WithAnimatedProgressBarAsync } from "source/app/presentation/Header/ProgressBar/LevelProgressBar/WithAnimatedProgressBar";
import { IDreamsState } from "source/app/presentation/MainPanel/Dreams/IDreamsState";
import Hyperlink from "source/app/presentation/Shared/Link/Hyperlink";
import Render from "source/app/presentation/Shared/Render";
import { StyleClass } from "source/app/presentation/Shared/Styles/CSS";
import Data from "source/app/services/Data";
import ClientDataProvider from "source/app/services/External/ClientDataProvider/ClientDataProvider";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { State } from "source/app/services/UI/State/State";

export function ShowName(
    dream: IDream,
    setIsLoading: React.Dispatch<React.SetStateAction<boolean>>,
    prefix: string
) {
    React.useEffect(() => {
        ReactTooltip.rebuild();
    }, [dream.notes]);

    const isFixedDream = dream.attributes.includes(
        EDA[EDA.fixed]
    );

    const isTentativeDream = dream.attributes.includes(
        EDA[EDA.tentative]
    );

    const isImportantDream = dream.attributes.includes(
        EDA[EDA.important]
    );

    return (
        <Hyperlink
            key={dream.id}
            whenClicked={async () => {
                setIsLoading(true);
                dream.isresonating = !dream.isresonating;
                await UpdateDreamAsync(dream);
                setIsLoading(false);
            }}
        >
            <span
                className={StyleClass(
                    `showStackDreamName_${isImportantDream}`,
                    {
                        color: isImportantDream ? `gold` : `inherit`,
                    }
                )}
            >
                <Render id="stackDreamFixedIndicator" when={isFixedDream}>
                    ~
                </Render>
                {`${prefix} `}
                <Render
                    id="stackDreamTentativeIndicator"
                    when={isTentativeDream}
                >
                    {" "}
                    (possibly){" "}
                </Render>
                <span>{dream.name}</span>
                <Render
                    id="stackDreamNotesIndicator"
                    when={dream.notes !== ``}
                    tooltip={dream.notes}
                    withClasses={StyleClass(`stackDreamNotesIndicator`, {
                        fontSize: `7px`,
                    })}
                >
                    ...
                </Render>
            </span>
        </Hyperlink>
    );
}

export async function UpdateDreamAsync(dream: IDream) {
    return WithAnimatedProgressBarAsync(async () => {
        ChangeLocalDreamState(dream);
        await dreamService.UpdateDreamAsync(dream, ClientDataProvider);
        return Data.Load.Single.ByStateTarget<IDreamsState>("dreamsdata");
    });
}

function ChangeLocalDreamState(dream: IDream) {
    const dreams = State.ReadClass<IDreamsState>(ESharedComponent.Dreams);

    const dreamToChange = dreams.state.dreamsdata.find(
        (d) => d.id === dream.id
    );

    dreamToChange!.isresonating = dream.isresonating;
    dreams.setState({ dreamsdata: dreams.state.dreamsdata });
}
